import { NotificationProvider } from '@libs/templates/global-area';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import type { ReactNode } from 'react';
import {
  BooksProvider,
  CompanyProvider,
  CustomFieldSettingsProvider,
  MstSettingsProvider,
  OperationControlProvider,
  ProcessingMonthProvider,
  SpaceProvider,
} from '../context';

interface FaProvidersProps {
  children: ReactNode;
}

/**
 * FA のどの画面でも必要な provider 群。
 *
 * 既存UI（v1）の {@link ContainerWithContext} と新UI（v2）の {@link ContainerV2} より外側の
 * {@link FaContainer} で1度だけ mount する。入れ子の順序に依存関係があるので、ここに1つ持つ。
 */
export function FaProviders({ children }: FaProvidersProps) {
  return (
    <CompanyProvider>
      <SpaceProvider>
        <ProcessingMonthProvider>
          <NotificationProvider>
            <BooksProvider>
              <MstSettingsProvider>
                <CustomFieldSettingsProvider>
                  <OperationControlProvider>
                    <BackDropSpinnerProvider>{children}</BackDropSpinnerProvider>
                  </OperationControlProvider>
                </CustomFieldSettingsProvider>
              </MstSettingsProvider>
            </BooksProvider>
          </NotificationProvider>
        </ProcessingMonthProvider>
      </SpaceProvider>
    </CompanyProvider>
  );
}
